import { useMemo } from 'react';
import { useFetchData } from '../hooks/useFetchData';
import { useEnvironment } from '../contexts/EnvironmentContext';
import { v2ServicePath } from '../config';

// ── normalizers ────────────────────────────────────────────────────────────

function normalizeV2Tool(t) {
  const calls = t.call_count ?? 0;
  const errorCount = t.error_count ?? 0;
  const avgMs = t.avg_duration_ms ?? null;
  return {
    id: String(t.tool_id),
    name: t.tool_name,
    calls,
    total_duration: avgMs != null ? avgMs * calls : null,
    error_rate: calls > 0 ? Math.round((errorCount / calls) * 10000) / 100 : 0,
    agents: Array.isArray(t.agent_names) ? t.agent_names : [],
    security_alerts: 0,
    last_seen: t.last_seen ?? null,
  };
}

// ── hook ───────────────────────────────────────────────────────────────────

/**
 * Fetch and normalize the tools list for a service.
 */
export function useToolList(selectedAppId) {
  const { selectedEnvironment } = useEnvironment();

  const endpoint = useMemo(() => {
    if (!selectedAppId) return null;
    return v2ServicePath(selectedAppId, '/tools');
  }, [selectedAppId]);

  const { data, loading, error } = useFetchData({
    endpoint,
    enabled: !!selectedAppId && !!selectedEnvironment,
  });

  const tools = useMemo(() => {
    if (!data) return [];
    return (Array.isArray(data.data) ? data.data : []).map(normalizeV2Tool);
  }, [data]);

  return { tools, loading, error };
}
